import axios from 'axios'
import { Snapshot, Response, PresignedUrlResponse } from '@/models'
import * as HELPERS from '@/utils/helpers'
import notifMessage from '@/translations/notifMessage.json'
import ConfigConstants from '@/constants/Config.constants'
import { IUploadService } from '../IUploadService'

export class UploadService implements IUploadService {
  constructor(private endpointUrl: string) {}

  async getZipFile(): Promise<string> {
    return axios
      .get(this.endpointUrl, {})
      .then((data) => {
        return Promise.resolve(data.data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  }
  async getPresignedUrl(projectId: number): Promise<Response<PresignedUrlResponse>> {
    return axios
      .get(this.endpointUrl + `/project/${projectId}/snapshots/uploadSnapshot`, {
        headers: {
          'Content-Type': ConfigConstants.CONTENT_TYPES.YT_V1,
          Accept: '*/*',
        },
      })
      .then((data) => {
        return Promise.resolve(data.data)
      })
      .catch(() => {
        HELPERS.showTopAlertMessage(true, 'error', notifMessage.ERROR_ALERTS.COULDNT_GET_URL)
      })
  }

  async uploadFileToAWSS3(
    uploadUrl: string,
    file: File,
    additionalHeaders?: Record<string, string>,
  ): Promise<Response<Snapshot>> {
    return axios
      .put(uploadUrl, file, {
        headers: {
          'content-type': 'application/zip',
          Accept: '*/*',
          ...additionalHeaders,
        },
      })
      .then((data) => {
        return Promise.resolve(data.data)
      })
      .catch(() => {
        HELPERS.showTopAlertMessage(
          true,
          'error',
          notifMessage.ERROR_ALERTS.COULDNT_UPLOAD_SNAPSHOT,
        )
      })
  }
  async notifyUploadSnapshotFinished(
    filename: string,
    projectId: number,
    requestId: string,
  ): Promise<Response<Snapshot>> {
    return axios
      .get(
        this.endpointUrl +
          `/project/${projectId}/snapshots/uploadSnapshot/${requestId}/${filename}`,
        {
          data: {},
          headers: {
            'Content-Type': ConfigConstants.CONTENT_TYPES.YT_V1,
            Accept: ConfigConstants.CONTENT_TYPES.YT_V1,
          },
        },
      )
      .then((data) => {
        return Promise.resolve(data.data)
      })
      .catch(() => {
        HELPERS.showTopAlertMessage(
          true,
          'error',
          notifMessage.ERROR_ALERTS.COULDNT_UPLOAD_SNAPSHOT,
        )
      })
  }

  async uploadSnapshot(file: FormData, projectId: number): Promise<Response<Snapshot>> {
    return axios
      .post(this.endpointUrl + `/project/${projectId}/snapshots/uploadSnapshot`, file, {
        headers: {
          'content-type': 'multipart/form-data',
          Accept: '*/*',
        },
      })
      .then((data) => {
        return Promise.resolve(data.data)
      })
      .catch(() => {
        HELPERS.showTopAlertMessage(
          true,
          'error',
          notifMessage.ERROR_ALERTS.COULDNT_UPLOAD_SNAPSHOT,
        )
      })
  }
}
